module["exports"] = [
  0
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/address/postcode.js
// module id = 1057
// module chunks = 0